import React from 'react';
import { KoreanStudyTypeProvider } from './KoreanStudyTypeContext';
import KoreanStudyTypeIntro from './intro';
import KoreanStudyTypeTest from './question';
import KoreanStudyTypeComplete from './complete';
import KoreanStudyTypeSurvey from './survey';
import KoreanStudyTypePreview from './preview';
import KoreanStudyTypeFinish from './result';
import KoreanStudyTypeMakeAvatar from './makeavatar';

interface Props {
    subpath: string;
}

const KoreanStudyTypeRouter: React.FC<Props> = ({ subpath }) => {
    // Extract path for components that need it
    const getPath = () => {
        if (subpath.startsWith('/result')) {
            return subpath.replace('/result', '');
        }
        if (subpath.startsWith('/preview')) {
            return subpath.replace('/preview', '');
        }
        if (subpath.startsWith('/makeavatar')) {
            return subpath.replace('/makeavatar', '');
        }
        return subpath;
    };

    const renderRoute = () => {
        if (subpath === '/intro') {
            return <KoreanStudyTypeIntro />;
        } else if (subpath.startsWith('/question')) {
            return <KoreanStudyTypeTest path={subpath} />;
        } else if (subpath === '/complete') {
            return <KoreanStudyTypeComplete />;
        } else if (subpath === '/survey') {
            return <KoreanStudyTypeSurvey />;
        } else if (subpath.startsWith('/preview')) {
            return <KoreanStudyTypePreview path={getPath()} />;
        } else if (subpath.startsWith('/result')) {
            return <KoreanStudyTypeFinish path={getPath()} />;
        } else if (subpath.startsWith('/makeavatar')) {
            return <KoreanStudyTypeMakeAvatar path={getPath()} />;
        } else {
            return <KoreanStudyTypeIntro />;
        }
    };

    return (
        <KoreanStudyTypeProvider path={getPath()}>
            {renderRoute()}
        </KoreanStudyTypeProvider>
    );
};

export default KoreanStudyTypeRouter;
